import RtButton from './button/rtButton';
import RtButtonGroup from './button/rtButtonGroup';
import RtButtonSelect from './button/rtButtonSelect';
import RtView from './layout/rtView';
import RtContainer from './layout/rtContainer';
import RtHeader from './layout/rtHeader';
import RtContent from './layout/rtContent';
import RtFooter from './layout/rtFooter';
import lookup from './lookup';
import RtPicklist from './picklist';
import RtCard from './card/index';
import RtCardV1 from './card/rtCard';
import RtCardV2 from './card/rtCardV2';
import RtSection from './section/rtSection';
import RtSubSection from './section/rtSubSection';
import RtIcon from './icon/rtIcon';
import RtTag from './tag/rtTag';
import RtForm from './form/rtForm';
import RtFormItem from './form/rtFormItem';
import RtDynamicFormItem from './form/rtDynamicFormItem';
import RtInput from './form/rtInput';
import RtXpcInput from './form/rtXpcInput';
import RtDatePicker from './form/rtDatePicker';
import RtTimePicker from './form/rtTimePicker';
import RtDateRangePicker from './form/rtDateRangePicker';
import RtSwitch from './switch/rtSwitch';
import RtTooltip from './tooltip/rtTooltip';
import RtInputNumber from './form/rtInputNumber';
import RtInputMoney from './form/rtInputMoney';
import RtUploadVideo from './uploadVideo/rtUploadVideo';
import RtUploadFilelist from './uploadFilelist/rtUploadFilelist';
import RtUploadSlideFilelist from './uploadSlideFilelist/rtUploadSlideFile';
import RtAddress from './address/rtAddress';
import RtAddressCascader from './address/rtAddressCascader';
import RtKind from './kind/rtKind';
import RtMsgNotice from './msgNotice/rtMsgNotice';
import RtBatchList from './batchList/rtBatchList';
import RtPopover from './popover/rtPopover';
import RtPopconfirm from './popconfirm/rtPopconfirm';

import RtRow from './row/rtRow';
import RtCol from './col/rtCol';
import RtTable from './table/rtTable';
import RtTableColumn from './table/rtTableColumn';
import ElTableColumn from '../element-ui/packages/table-column';
import ElPopover from '../element-ui/packages/popover';
import RtTableDropdown from './table/rtTableDropdown';
import RtAdvanceTableGroup from './table/rtAdvanceTableGroup';
import RtAdvanceTableItem from './table/rtAdvanceTableItem';

import RtSearch from './search/rtSearch';
import RtQuery from './search/rtQuery';

import RtTabs from './tabs/tabs';
// import RtContentTabs from './tabs/rtContentTabs';
import RtTabPane from './tabs/tab-pane';

import RtHeaderButtonGroup from './business/common/rtHeaderButtonGroup';
import RtHeaderIcon from './business/common/rtHeaderIcon';
import RtHeaderTitle from './business/common/rtHeaderTitle';
import RtAttr from './business/common/rtAttr';
import RtVerticalAttr from './business/common/rtVerticalAttr';

import RtDetailHeader from './business/detail/rtDetailHeader';
import RtDetailItem from './business/detail/rtDetailItem';
import RtDetailAside from './business/detail/rtDetailAside';
import RtDetailButton from './business/detail/rtDetailButton';
import RtDetailBottom from './business/detail/rtDetailBottom';

import RtListHeader from './business/list/rtListHeader';
import RtListFilter from './business/list/rtListFilter';
import RtListButtonGroup from './business/list/rtListButtonGroup';

import RtDropDown from './dropdown/rtDropdown';
import RtDropDownMenu from './dropdown/rtDropdownMenu';
import RtDropDownItem from './dropdown/rtDropdownItem';

import RtRadioGroup from './radio/rtRadioGroup';
import RtRadio from './radio/rtRadio';
import RtRadioButton from './radio/rtRadioButton';

import RtCheckboxGroup from './checkbox/rtCheckboxGroup';
import RtCheckbox from './checkbox/rtCheckbox';
import RtCheckboxButton from './checkbox/rtCheckboxButton';

import rtNavbar from './navbar/rtNavbar';

import RtTree from './tree/rtTree';
import RtUpload from './upload/rtUpload';
import RtUploadOrigin from './upload/rtUploadOrigin';

import RtLabelGroup from './label/rtLabelGroup';
import RtLabelItem from './label/rtLabelItem';

import RtDefaultImage from './defaultImage/rtDefaultImage';
import RtDescriptions from './descriptions/rtDescriptions';
import RtDescriptionsItem from './descriptions/rtDescriptionsItem';

import RtDialog from './dialog/rtDialog';

import RtCollapseItem from './collapse/rtCollapseItem';
import RtCollapse from './collapse/rtCollapse';

import RtAttachment from './attachment/rtAttachment';

import RtApproval from './approval/rtApproval';
import RtApprovalItem from './approval/rtApprovalItem';

import RtCascader from './cascader/rtCascader';

import RtButtonList from './button/rtButtonList';
import RtDrawer from './drawer/rtDrawer';
import { Breadcrumb, BreadcrumbItem } from './breadcrumb';
import { Stateline, StatelineItem, StatelineContent } from './stateline';
import RtProductItem from './product/rtProductItem';

// import RtAddress from './cascader/rtAddress';
import RtBacktop from './backtop/rtBacktop.vue';
import RtListDropdown from './business/list/rtListDropdown';
import RtLink from './link/rtLink';
import RtBadge from './badge/rtBadge.vue';

import RtOriginProgress from './progress/rtOriginProgress';
import RtProgress from './progress/rtProgress';

import RtFormWrapper from './form/rtFormWrapper';
import RtSteps from './steps/main';
import RtDivider from './divider/rtDivider';
import RtNode from './node/rtNode';
import RtAlert from './alert/rtAlert';
import RtAvatar from './avatar';
import RtOverlay from './overlay/rtOverlay';
import RtTimeline from './timeline/rtTimeline';
import RtTimelineItem from './timeline/rtTimelineItem';
import RtNoticeCenter from './noticecenter/rtNoticecenter';
import RtPagination from './pagination/rtPagination';
import RtPager from './pagination/pager';

import RtMenu from './menu/rtMenu';
import RtSubmenu from './menu/rtSubmenu';
import RtImagePreview from './imagePreview/rtImagePreview.vue';
import RtSlider from './slider/main.vue';
import ElScrollbar from '../element-ui/packages/scrollbar';
import RtSidebarMenu from './sidebarMenu';
import RtColorPicker from './colorPicker/rtColorPicker';
import RtCalendar from './calendar/rtCalendar.vue';

import RtAddressRecognition from './address/rtRecognition';

const components = [
  { name: RtSlider.name, component: RtSlider },
  { name: RtNoticeCenter.name, component: RtNoticeCenter },
  { name: RtOverlay.name, component: RtOverlay },
  { name: RtMenu.name, component: RtMenu },
  { name: RtSubmenu.name, component: RtSubmenu },
  { name: RtAvatar.name, component: RtAvatar },
  { name: RtButton.name, component: RtButton },
  { name: RtButtonGroup.name, component: RtButtonGroup },
  { name: RtButtonSelect.name, component: RtButtonSelect },
  { name: RtView.name, component: RtView },
  { name: RtContainer.name, component: RtContainer },
  { name: RtHeader.name, component: RtHeader },
  { name: RtContent.name, component: RtContent },
  { name: RtFooter.name, component: RtFooter },
  { name: lookup.RtLookup.name, component: lookup.RtLookup },
  { name: lookup.RtLookupView.name, component: lookup.RtLookupView },
  { name: lookup.RtCrmLookup.name, component: lookup.RtCrmLookup },
  { name: RtPicklist.name, component: RtPicklist },
  { name: RtCard.name, component: RtCard },
  { name: RtCardV1.name, component: RtCardV1 },
  { name: RtCardV2.name, component: RtCardV2 },
  { name: RtSection.name, component: RtSection },
  { name: RtSubSection.name, component: RtSubSection },
  { name: RtIcon.name, component: RtIcon },
  { name: RtTag.name, component: RtTag },
  { name: RtForm.name, component: RtForm },
  { name: RtFormItem.name, component: RtFormItem },
  { name: RtDynamicFormItem.name, component: RtDynamicFormItem },
  { name: RtInput.name, component: RtInput },
  { name: RtXpcInput.name, component: RtXpcInput },
  { name: RtDatePicker.name, component: RtDatePicker },
  { name: RtTimePicker.name, component: RtTimePicker },
  { name: RtDateRangePicker.name, component: RtDateRangePicker },
  { name: RtSwitch.name, component: RtSwitch },
  { name: RtTooltip.name, component: RtTooltip },
  { name: RtInputNumber.name, component: RtInputNumber },
  { name: RtInputMoney.name, component: RtInputMoney },
  { name: RtUploadVideo.name, component: RtUploadVideo },
  { name: RtUploadFilelist.name, component: RtUploadFilelist },
  { name: RtUploadSlideFilelist.name, component: RtUploadSlideFilelist },
  { name: RtRow.name, component: RtRow },
  { name: RtCol.name, component: RtCol },
  { name: RtButtonList.name, component: RtButtonList },
  { name: RtDrawer.name, component: RtDrawer },
  { name: Stateline.name, component: Stateline },
  { name: StatelineItem.name, component: StatelineItem },
  { name: StatelineContent.name, component: StatelineContent },
  { name: Breadcrumb.name, component: Breadcrumb },
  { name: BreadcrumbItem.name, component: BreadcrumbItem },
  { name: RtProductItem.name, component: RtProductItem },

  { name: RtTable.name, component: RtTable },
  { name: RtTableColumn.name, component: RtTableColumn },
  { name: ElTableColumn.name, component: ElTableColumn },
  { name: ElPopover.name, component: ElPopover },
  { name: RtTableDropdown.name, component: RtTableDropdown },
  { name: RtAdvanceTableGroup.name, component: RtAdvanceTableGroup },
  { name: RtAdvanceTableItem.name, component: RtAdvanceTableItem },

  { name: RtSearch.name, component: RtSearch },
  { name: RtQuery.name, component: RtQuery },

  {
    name: RtTabs.name,
    deprecatedNames: RtTabs.deprecatedNames,
    component: RtTabs
  },
  // { name: RtContentTabs.name, component: RtContentTabs },
  { name: RtTabPane.name, component: RtTabPane },

  { name: RtHeaderButtonGroup.name, component: RtHeaderButtonGroup },
  { name: RtHeaderIcon.name, component: RtHeaderIcon },
  { name: RtHeaderTitle.name, component: RtHeaderTitle },
  { name: RtAttr.name, deprecatedNames: RtAttr.deprecatedNames, component: RtAttr },
  { name: RtVerticalAttr.name, component: RtVerticalAttr },

  { name: RtDetailHeader.name, component: RtDetailHeader },
  { name: RtDetailItem.name, component: RtDetailItem },
  { name: RtDetailAside.name, component: RtDetailAside },
  { name: RtDetailButton.name, component: RtDetailButton },
  { name: RtDetailBottom.name, component: RtDetailBottom },

  { name: RtListFilter.name, component: RtListFilter },
  { name: RtListHeader.name, component: RtListHeader },
  { name: RtListButtonGroup.name, component: RtListButtonGroup },

  { name: rtNavbar.name, component: rtNavbar },

  { name: RtDropDown.name, component: RtDropDown },
  { name: RtDropDownMenu.name, component: RtDropDownMenu },
  { name: RtDropDownItem.name, component: RtDropDownItem },

  { name: RtRadioGroup.name, component: RtRadioGroup },
  { name: RtRadio.name, component: RtRadio },
  { name: RtRadioButton.name, component: RtRadioButton },

  { name: RtCheckboxGroup.name, component: RtCheckboxGroup },
  { name: RtCheckbox.name, component: RtCheckbox },
  { name: RtCheckboxButton.name, component: RtCheckboxButton },
  { name: RtTree.name, component: RtTree },
  { name: RtUpload.name, component: RtUpload },
  { name: RtUploadOrigin.name, component: RtUploadOrigin },

  { name: RtLabelGroup.name, component: RtLabelGroup },
  { name: RtLabelItem.name, component: RtLabelItem },

  { name: RtDefaultImage.name, component: RtDefaultImage },
  { name: RtDescriptions.name, component: RtDescriptions },
  { name: RtDescriptionsItem.name, component: RtDescriptionsItem },

  { name: RtDialog.name, component: RtDialog },

  { name: RtCollapseItem.name, component: RtCollapseItem },
  { name: RtCollapse.name, component: RtCollapse },

  { name: RtAttachment.name, component: RtAttachment },

  { name: RtApproval.name, component: RtApproval },
  { name: RtApprovalItem.name, component: RtApprovalItem },

  { name: RtCascader.name, component: RtCascader },
  { name: RtAddress.name, component: RtAddress },
  { name: RtAddressCascader.name, component: RtAddressCascader },
  { name: RtKind.name, component: RtKind },
  { name: RtMsgNotice.name, component: RtMsgNotice },
  { name: RtBatchList.name, component: RtBatchList },
  { name: RtPopover.name, component: RtPopover },
  { name: RtPopconfirm.name, component: RtPopconfirm },
  { name: RtListDropdown.name, component: RtListDropdown },
  { name: RtLink.name, component: RtLink },
  { name: RtBadge.name, component: RtBadge },
  { name: RtOriginProgress.name, component: RtOriginProgress },
  { name: RtProgress.name, component: RtProgress },
  { name: RtFormWrapper.name, component: RtFormWrapper },
  { name: RtSteps.name, component: RtSteps },
  { name: RtDivider.name, component: RtDivider },
  { name: RtNode.name, component: RtNode },
  { name: RtAlert.name, component: RtAlert },
  { name: RtTimeline.name, component: RtTimeline },
  { name: RtTimelineItem.name, component: RtTimelineItem },
  { name: RtPagination.name, component: RtPagination },
  { name: RtPager.name, component: RtPager },
  { name: RtBacktop.name, component: RtBacktop },
  { name: RtImagePreview.name, component: RtImagePreview },
  { name: ElScrollbar.name, component: ElScrollbar },
  { name: RtSidebarMenu.name, component: RtSidebarMenu },
  { name: RtAddressRecognition.name, component: RtAddressRecognition },
  { name: RtColorPicker.name, component: RtColorPicker },
  { name: RtCalendar.name, component: RtCalendar }
];

export default components;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/index.js